import { Timeline, timelineItemClasses } from '@mui/lab'
import React from 'react'
import TimeLineComp from './TimeLineComp'
import SchoolIcon from '@mui/icons-material/School';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import GradeIcon from '@mui/icons-material/Grade';
import { Typography } from '@mui/material';
import { HeadingText } from '../StyledComponents';

function Experience() {
  return (
    <>
        <HeadingText text="Experience" my={4} sx={{fontSize:{xs:"1rem",sm:"1.5rem",md:"1.7rem"},}} data-aos="fade-up" data-aos-duration="2000">
        Experience
        </HeadingText>
        <Timeline  sx={{
            [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
            },
            }}
        >
            <TimeLineComp title="Codegnan IT Solutions" orgName="Developer & Trainer" loc="Hyderabad" year="2025" Icon={SchoolIcon} connector/>
            <TimeLineComp title="Cognifo" orgName="Freelancer | Developer and Trainer" loc="Hyderabad" year="2024" Icon={GradeIcon} connector/>
            <TimeLineComp title="Mphasis" orgName="Trainee Associate Software Engineer" loc="Chennai" year="2023" Icon={LibraryBooksIcon}/>

        </Timeline>
    </>
  )
}

export default Experience